export default __webpack_public_path__ + "static/media/current_training.ab711e26.png";